export function natureAvatar(user = {}) {
  const seed = String(user.username || user.id || 'SweetLove')
  let hash = 2166136261
  for (let index = 0; index < seed.length; index++) hash = Math.imul(hash ^ seed.charCodeAt(index), 16777619)
  return `/avatars/nature-${String((hash >>> 0) % 24 + 1).padStart(2, '0')}.svg`
}
